import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { FormInputNew } from 'components/Input/FormInputNew';

interface IProps {
	onChange: (value: string) => void;
	setId: string;
}

export const PaymentDetailsField: React.FC<IProps> = React.memo(({ onChange, setId }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterPaymentDetails') }], [t]);

	return (
		<FormInputNew
			testId="PaymentDetails"
			name={`paymentDetails-${setId}`}
			label="paymentDetailsLabel"
			onChange={onChange}
			validationRules={validationRules}
			maxLength={640}
		/>
	);
});
